import React, { useState } from "react";
import invoiceContext from "./invoiceContext";
import API_BASE from "../../apiConfig";

const InvoiceState = (props) => {
  const host = API_BASE; // backend API endpoint

  const [invoices, setInvoices] = useState([]);

  // ✅ Fetch all invoices
  const fetchAllInvoices = async () => {
    try {
      const response = await fetch(`${host}/api/invoices/fetchallinvoices`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("token"),
        },
      });
      const json = await response.json();
      setInvoices(json);
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  };

  // ✅ Delete invoice
  const deleteInvoice = async (id) => {
    try {
      const response = await fetch(`${host}/api/invoices/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("token"),
        },
      });

      if (!response.ok) {
        throw new Error("Failed to delete invoice");
      }

      // Update local state
      setInvoices((prev) => prev.filter((invoice) => invoice._id !== id));
    } catch (error) {
      console.error("Error deleting invoice:", error);
      throw error;
    }
  };

  // ✅ CANCEL INVOICE (NEW)
  const cancelInvoice = async (id) => {
    try {
      const response = await fetch(`${host}/api/invoices/cancel/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("token"),
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to cancel invoice");
      }

      // Refresh list OR local update
      await fetchAllInvoices();

      return data;
    } catch (error) {
      console.error("Error cancelling invoice:", error);
      throw error;
    }
  };

  return (
    <invoiceContext.Provider
      value={{
        invoices,
        fetchAllInvoices,
        deleteInvoice,
        cancelInvoice, 
      }}
    >
      {props.children}
    </invoiceContext.Provider>
  );
};

export default InvoiceState;
